import React from 'react'
import Map from '../../layouts/general/featured/Map'
import './styles/MapaContactanos.css'

export const MapaContactanos = () => {
  return (
    <div className='mapaContactanos'><Map/></div>
  )
}
